<div class="row mt-5">
  <div class="col-12">
    <p class="fw-bold">
      {{
        !inUpdateViewState
          ? 'Would you like to export a GL file or setup a new recurring export?'
          : 'Update GL Setup'
      }}
    </p>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12 col-md-6 col-lg-5">
    <select [ngModel]="selected | async" (ngModelChange)="changeState($event)" class="form-control">
      <option [ngValue]="null" disabled>Select Export</option>
      <option *ngFor="let config of glConfigs | async" [ngValue]="config.Id">
        {{ config.Name }}
      </option>
      <option *ngIf="!inUpdateViewState" [ngValue]="0">+ Create New</option>
    </select>
  </div>
</div>
<hr />
<form *ngIf="(selected | async) != null && form != null" [formGroup]="form" (ngSubmit)="submit()">
  <div
    class="row"
    *ngIf="(clientSetup | async) != null && !(clientSetup | async).HasCentralChecking">
    <div class="col-12 col-md-6 col-lg-5">
      <label for="balanceType">Balance Checks or Totals</label>
      <select class="form-control" formControlName="balanceType" id="balanceType">
        <option [ngValue]="null" disabled>Select Balance Type</option>
        <option [ngValue]="balanceTypes.Checks">Checks</option>
        <option [ngValue]="balanceTypes.Totals">Totals</option>
      </select>
      <small
        class="form-text text-danger"
        *ngIf="form.get('balanceType').invalid && form.get('balanceType').touched">
        You must select a Balance Type.
      </small>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <label for="exportTo">Export To</label>
      <select class="form-control" formControlName="exportTo" id="exportTo">
        <option [ngValue]="null" disabled>Select Export Type</option>
        <option [ngValue]="exportTypes.CSV">CSV</option>
        <option [ngValue]="exportTypes.QBO">Quickbooks Online</option>
        <option [ngValue]="exportTypes.IIF">Quickbooks Desktop (.iif)</option>
      </select>
      <small
        class="form-text text-danger"
        *ngIf="form.get('exportTo').invalid && form.get('exportTo').touched">
        You must select an Export Type.
      </small>
    </div>
    <div
      *ngIf="isClientPortal && connectedToQbo && form.get('exportTo').value == exportTypes.QBO"
      class="col-12 col-md-6 col-lg-4 d-flex flex-column justify-content-center">
      <small class="cp-green fst-italic align-middle mt-auto mb-0">Account Synced. </small>
      <small class="cp-green fst-italic align-middle mt-0 mb-auto"
        >Note: The QBO Account information will not be saved unless you submit the form.</small
      >
    </div>
    <div
      class="col-12 col-md-6 col-lg-5"
      *ngIf="
        isClientPortal &&
        !connectedToQbo &&
        ((selected | async) == 0 || inUpdateViewState) &&
        form.get('exportTo').value == exportTypes.QBO
      ">
      <button (click)="startQboConnection()" type="button" class="btn btn-tertiary sync">
        Sync Accounts
      </button>
    </div>
  </div>
  <div
    class="row"
    *ngIf="
      form.get('exportTo').value == exportTypes.QBO &&
      form.get('balanceType').value == balanceTypes.Totals
    ">
    <div class="col-12 col-md-6 col-lg-5">
      <label for="useClasses">Use Classes</label>
      <select class="form-control" formControlName="useClasses" id="useClasses">
        <option [ngValue]="null" disabled>Select Option</option>
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <small
        class="form-text text-danger"
        *ngIf="form.get('useClasses').invalid && form.get('useClasses').touched">
        You must select an option.
      </small>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <label for="submitWithoutApproval">Submit Without Approval</label>
      <select
        class="form-control"
        formControlName="submitWithoutApproval"
        id="submitWithoutApproval">
        <option [ngValue]="null" disabled>Select Option</option>
        <option
          *ngIf="canAddAutomatic(selectedObj | async) | async"
          [ngValue]="approvalTypes.Automatic">
          Yes
        </option>
        <option
          *ngIf="form.get('exportTo').value == exportTypes.QBO"
          [ngValue]="approvalTypes.Approval">
          No
        </option>
        <option [ngValue]="approvalTypes.Manual">Manual</option>
      </select>
      <small
        class="form-text text-danger"
        *ngIf="
          form.get('submitWithoutApproval').invalid && form.get('submitWithoutApproval').touched
        ">
        You must select an option.
      </small>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <label for="frequency">Frequency</label>
      <select class="form-control" formControlName="frequency" id="frequency">
        <option [ngValue]="null" disabled>Select Frequency</option>
        <option [ngValue]="frequencies.Payroll">Current Payroll</option>
        <option [ngValue]="frequencies.MTD">Monthly</option>
        <option [ngValue]="frequencies.QTD">Quarterly</option>
        <option [ngValue]="frequencies.YTD">Annually</option>
        <option [ngValue]="frequencies.DateRange">Custom</option>
      </select>
      <small
        class="form-text text-danger"
        *ngIf="form.get('frequency').invalid && form.get('frequency').touched">
        You must select a Frequency.
      </small>
    </div>
  </div>
  <div class="row" *ngIf="form.get('frequency').value == frequencies.DateRange">
    <div class="col-12 col-md-6 col-lg-5">
      <label for="timeframe">Timeframe</label>
      <lib-date-range-picker id="timeframe" formControlName="timeframe"></lib-date-range-picker>
    </div>
  </div>
  <div *ngIf="(selected | async) == 0 || inUpdateViewState" class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <label for="name">Name</label>
      <input class="form-control" formControlName="name" id="name" placeholder="Enter File Name" />
      <span
        class="form-text text-danger"
        *ngIf="form.get('name').invalid && form.get('name').touched">
        <small *ngIf="form.get('name').errors?.['required']">You must provide a name.</small>
        <small *ngIf="form.get('name').errors?.['minlength']"
          >The file name should be at least 3 characters long.</small
        >
        <small *ngIf="form.get('name').errors?.['duplicateName']"
          >{{ form.get('name').value }} file name is already in use.</small
        >
      </span>
    </div>
  </div>
  <div class="row" *ngIf="(balance | async) != null" style="margin-bottom: 20px">
    <div class="col-12">
      <span class="fw-bold">Balance: </span>
      <span *ngIf="(balance | async) >= 0" class="text-cp-green">{{
        balance | async | currency: '' : ''
      }}</span>
      <span *ngIf="(balance | async) < 0" class="text-danger"
        >({{ balance | async | absoluteValue | currency: '' : '' }})</span
      >
    </div>
  </div>

  <ng-container *ngIf="!inUpdateViewState">
    <div *ngIf="(selected | async) == 0" class="row">
      <div class="col-12 col-md-6 col-lg-5">
        <small class="form-text">
          *Having trouble keeping your bookkeeping in order, or deciding which setup is best for
          your organization? Please get in touch with our Payroll Specialists and they can assist
          you.
        </small>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <ng-container *ngIf="(selected | async) == 0">
          <button type="button" class="btn btn-secondary me-3" (click)="navigateToPayrollHub()">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Save</button>
        </ng-container>
        <ng-container *ngIf="(selected | async) != 0">
          <button class="btn btn-primary" type="button" (click)="exportFile()">Export File</button>
          <button
            type="button"
            (click)="onShowMappings()"
            [disabled]="form.invalid"
            class="btn btn-link">
            Edit Mapping
          </button>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="inUpdateViewState">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-5">
        <button type="button" class="btn btn-secondary me-3" (click)="cancel()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Save</button>
        <button
          type="button"
          (click)="onEditMapping()"
          [disabled]="form.invalid"
          class="btn btn-link">
          Edit Mapping
        </button>
        <div class="mt-2">
          <small class="form-text">
            *Having trouble keeping your bookkeeping in order, or deciding which setup is best for
            your organization? Please get in touch with our Payroll Specialists and they can assist
            you.
          </small>
        </div>
      </div>
    </div>
  </ng-container>
</form>
